import React, { useState, useMemo, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Table,
  Modal,
  Label,
  Form,
  Input,
  ModalBody,
} from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import secureLocalStorage from "react-secure-storage"
import { customGlobalFilter } from "utils/common-helpers"
import {
  pendingInvoiceColumns,
  ReceiptsInvoiceColumns,
  requestedInvoiceColumns,
} from "utils/columns/ElementsColumns/financeColumns"
import { colourStyles } from "utils/common-options"
import Select from "react-select"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
  FetchNodePutData,
  FetchPostData,
} from "utils/common-fetchData"
import Swal from "sweetalert2"
import axios from "axios"
import moment from "moment"
import HTMLDocx from "html-docx-js/dist/html-docx"
import configure from "configure"
import CreateCustomer from "./CustomerCreate"
import { useNavigate } from "react-router-dom"
import html2pdf from "html2pdf.js"

function TableContainer({
  columns,
  data,
  allData,
  status,
  setStatus,
  setData,
  staticPendingCustomer,
  totalReceipts,
  setTotalReceipts,
  isPrivilegedUser,
  showTitle = true,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      autoResetPage: false,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state
  const [ztplReceipts, setZtplReceipts] = useState([])
  const [zithasReceipts, setZithasReceipts] = useState([])
  const [finalReceipts, setFinalReceipts] = useState([])
  const [invoiceType, setInvoiceType] = useState(isPrivilegedUser ? "all" : "ztpl")

  useEffect(() => {
    setPageSize(10)
  }, [])
  // Render the UI for your table
  const [fixedHeading, setFixedHeading] = useState(false)
  document.addEventListener("scroll", () => {
    if (window.scrollY > 40) {
      setFixedHeading(true)
    } else {
      setFixedHeading(false)
    }
  })


  const getReceiptsList = () => {
    if (!allData) return []

    const ztplList = Array.isArray(allData?.ztpl_invoice)
      ? allData.ztpl_invoice
        .filter(
          inv =>
            inv.due_flag == 1 &&
            inv.receipt_status == 0 &&
            inv.tax_inv_no !== null
        )
        .map(inv => ({
          ...inv,
          invoiceType: "ztpl",
        }))
      : []

    const zithasList = Array.isArray(allData?.zithas_invoice)
      ? allData.zithas_invoice
        .filter(inv => inv.due_flag == 1)
        .map(inv => ({
          ...inv,
          invoiceType: "zithas",
        }))
      : []

    const merged = [...ztplList, ...zithasList]

    setZtplReceipts(ztplList)
    setZithasReceipts(zithasList)
    setFinalReceipts(merged)

    return merged
  }

  useEffect(() => {
    if (allData) {
      getReceiptsList()
    }
  }, [allData])


  const ztplPendingInvoices =
    allData?.ztpl_invoice?.filter(
      inv => inv?.due_flag == 0 && inv.approve == 1
    ) || []

  const zithasPendingInvoices =
    allData?.zithas_invoice?.filter(
      inv => inv?.due_flag == 0 && inv.approve == 1
    ) || []

  const allPendingInvoices = [...ztplPendingInvoices, ...zithasPendingInvoices]

  const allReceipts = [...(ztplReceipts || []), ...(zithasReceipts || [])]

  return (
    <div>
      <Row>
        <Col xl="12">
          <div className="card-body ">
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div className="mb-3 text-purple fs-5 fw-bold d-flex align-items-center gap-3">
                {showTitle && <span>Pending Invoices</span>}

                <select
                  className="form-select"
                  style={{ width: "120px" }}
                  value={invoiceType}
                  onChange={e => {
                    const type = e.target.value
                    setInvoiceType(type)

                    switch (type) {
                      case "ztpl":
                        setStatus("ztpl")
                        setData(ztplPendingInvoices)
                        break

                      case "zithas":
                        setStatus("zithas")
                        setData(zithasPendingInvoices)
                        break

                      case "all":
                        setStatus("all")
                        setData(allPendingInvoices)
                        break

                      default:
                        setStatus("all")
                        setData(allPendingInvoices)
                    }
                  }}
                >
                  <option value="all">All</option>
                  <option value="ztpl">ZTPL</option>
                  <option value="zithas">Zithas</option>
                </select>
              </div>
            </div>
            <Row className="mb-2 justify-content-between">
              <div className="mb-3 mb-md-0 d-flex justify-space-between align-items-center">
                <div className="d-flex gap-3 align-items-center col-md-6">
                  <div className="">
                    <select
                      className="border-radius form-select"
                      style={{ width: "100px" }}
                      value={pageSize}
                      onChange={e => setPageSize(e.target.value)}
                    >
                      {[10, 25, 50, 100].map(pageSize => (
                        <option key={pageSize} value={pageSize}>
                          Show {pageSize}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex gap-4 align-items-center col-md-12">
                    <div
                      className={`general-box cursor-pointer ${status === invoiceType ? "bg-purple text-white" : ""
                        }`}
                      onClick={() => {
                        setStatus(invoiceType)

                        if (invoiceType === "ztpl") {
                          setData(ztplPendingInvoices)
                        } else if (invoiceType === "zithas") {
                          setData(zithasPendingInvoices)
                        } else {
                          setData(allPendingInvoices)
                        }
                      }}
                    >
                      <h5 className="text-purple mb-0">
                        Pending Invoices :
                        <span
                          className={`ms-2 ${status === invoiceType
                            ? "text-white"
                            : "text-purple"
                            }`}
                        >
                          {invoiceType === "ztpl"
                            ? ztplPendingInvoices.length
                            : invoiceType === "zithas"
                              ? zithasPendingInvoices.length
                              : allPendingInvoices.length}
                        </span>
                      </h5>
                    </div>

                    {/* Receipts */}
                    {isPrivilegedUser && (
                      <div
                        className={`general-box cursor-pointer ${status === `${invoiceType}-receipts`
                          ? "bg-purple text-white"
                          : "text-primary"
                          }`}
                        onClick={() => {
                          setStatus(`${invoiceType}-receipts`)

                          if (invoiceType === "ztpl") {
                            setData(ztplReceipts || [])
                          } else if (invoiceType === "zithas") {
                            setData(zithasReceipts || [])
                          } else {
                            setData(allReceipts)
                          }
                        }}
                      >
                        <h5 className="text-purple mb-0">
                          Receipts :
                          <span className="ms-2">
                            {invoiceType === "ztpl"
                              ? ztplReceipts?.length || 0
                              : invoiceType === "zithas"
                                ? zithasReceipts?.length || 0
                                : allReceipts.length}
                          </span>
                        </h5>
                      </div>
                    )}

                    {/* Requested */}
                    {isPrivilegedUser && (
                      <div
                        className={`general-box cursor-pointer ${status === "requested"
                          ? "bg-purple text-white"
                          : "text-primary"
                          }`}
                        onClick={() => {
                          setStatus("requested")
                          setData(staticPendingCustomer)
                        }}
                      >
                        <h5 className="text-purple mb-0">
                          Lead Requested Invoices :
                          <span className="ms-2">
                            {staticPendingCustomer?.length || 0}
                          </span>
                        </h5>
                      </div>
                    )}
                  </div>

                </div>



                <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <div className="col-11 cusrtom_search_box">
                    <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
                      <div className="d-flex">
                        <div className="position-relative w-100">
                          <label
                            htmlFor="search-bar-0"
                            className="search-label w-100 mb-0"
                          >
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <input
                              onChange={e => setGlobalFilter(e.target.value)}
                              id="search-bar-0"
                              type="text"
                              className="border-radius form-control rounded h-100 w-100"
                              placeholder={`Search...`}
                              value={globalFilter || ""}
                            />
                          </label>
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
            <div className="position-relative table-responsive">
              <Table className="table table-bordered mt-4" {...getTableProps()}>
                <thead className={`fixed_view_payment_table`}>
                  {headerGroups.map((headerGroup, i) => (
                    <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          key={index}
                          className={`t-col-${index + 1} ${column.className}`}
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div className="d-flex align-items-center">
                            <span className="flex-grow-1 text-center header-text">
                              {column.render("Header")}
                            </span>
                            {column.isShortIcon && (
                              <span
                                onClick={() =>
                                  column.getSortByToggleProps().onClick()
                                }
                                className="d-flex align-items-center ms-2"
                              >
                                <i
                                  title="Ascending"
                                  className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                    }`}
                                ></i>
                                <i
                                  title="Descending"
                                  className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                    }`}
                                ></i>
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody
                  className="fix-introducer-header"
                  {...getTableBodyProps()}
                >
                  {page.map((row, i) => {
                    prepareRow(row)
                    return (
                      <tr
                        className={`row-hover `}
                        {...row.getRowProps()}
                        key={i}
                      >
                        {row.cells.map((cell, index) => (
                          <td
                            key={index}
                            className={`t-col-${index + 1} ${cell.column.className
                              }`}
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </div>
            <Row className="justify-content-md-end justify-content-center align-items-center">
              <NewPagination
                gotoPage={gotoPage}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                pageSize={pageSize}
                page={page}
                data={data}
                nextPage={nextPage}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  )
}

const PendingInvoices = ({ showTitle = true }) => {
  const [modal_Access, setAccessDenied] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [allData, setAllData] = useState([])
  const [paymentMode, setPaymentMode] = useState(false)
  const [paymentOption, setPaymentOption] = useState([])
  const token = secureLocalStorage.getItem("auth_token")
  const [invoiceDetail, setInvoiceDetail] = useState({})
  const [transactionId, setTransactionId] = useState("")
  const [payment, setPayment] = useState([])
  const [receivedDate, setReceivedDate] = useState("")
  const [amount, setAmount] = useState("")
  const [tds, setTds] = useState("")
  const [transactionCharge, setTransactionCharge] = useState("")
  const [description, setDescription] = useState("")
  const [historyData, setHistoryData] = useState([])
  const [status, setStatus] = useState("ztpl")
  const [isEditMode, setEditMode] = useState(false)
  const [customerOpen, setCustomerOpen] = useState(false)
  const [editingPaymentId, setEditingPaymentId] = useState(null)
  const [pendingCustomer, setPendingCustomer] = useState([])
  const [leadId, setLeadId] = useState("")
  const [tempCustomerId, setTempCustomerId] = useState("")
  const [isEdit, setIsEdit] = useState(false)
  const [customerDetails, setCustomerDetails] = useState({})
  const [invoiceOpen, setInvoiceOpen] = useState(false)
  const [invoiceNo, setInvoiceNo] = useState("")
  const [totalReceipts, setTotalReceipts] = useState()

  const isPrivilegedUser = [1, 32, 4, 46].includes(Number(localStorage?.getItem("auth_id")))

  const navigate = useNavigate()
  const [columnKey, setColumnKey] = useState(false)
  const toggleLoading = loading => {
    setLoading(loading)
  }

  const resetForm = () => {
    setTransactionId("")
    setPayment([])
    setReceivedDate("")
    setAmount("")
    setTds("")
    setTransactionCharge("")
    setDescription("")
    setEditMode(false)
    setEditingPaymentId(null)
  }

  const onEdit = obj => {
    if (isEditMode && editingPaymentId === obj.id) {
      // Exit edit mode if clicking the same payment record
      resetForm()
    } else {
      // Enter edit mode with selected payment details
      setTransactionId(obj.transaction_id || "")
      setPayment({ label: obj.payment_mode, value: obj.payment_mode })
      setReceivedDate(obj.receive_date)
      setAmount(obj.amount)
      setTds(obj.tds || "")
      setTransactionCharge(obj.transaction_charge || "")
      setDescription(obj.transaction_detail || "")
      setEditMode(true)
      setEditingPaymentId(obj.id)
    }
  }

  const onPaymentRecord = async obj => {
    const res = await fetchData(
      toggleLoading,
      `${status === "zithas"
        ? `zithasPaymentHistory/${obj?.id}`
        : `paymentHistory/${obj?.id}`
      }`,
      token
    )
    if (res?.success) {
      setHistoryData(res?.data?.history)
      setPaymentMode(true)
      setInvoiceDetail({
        ...obj,
        due_amount: res?.data?.due_amount,
      })
    }
  }

  const onCovertTax = id => {
    Swal.fire({
      icon: "warning",
      title: "Are You Sure ?",
      text: "You Want to Convert Tax to Invoice?",
      showCancelButton: true,
      confirmButtonText: "Yes, convert it!",
      cancelButtonText: "No, cancel!",
    }).then(async result => {
      if (result?.isConfirmed) {
        const res = await fetchData(
          toggleLoading,
          `convert_invoice/${id}`,
          token
        )
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Invoice Converted Successfully",
          }).then(() => {
            setData(
              res.data.ztpl_invoice.filter(
                inv => inv.due_flag == 0 && inv.approve == 1
              )
            )
            setAllData(res.data)
          })
        }
      }
    })
  }

  const onDownloadReceipt = async obj => {
    const isZithas = obj.invoiceType === "zithas" || status === "zithas"

    const res = await fetchData(
      toggleLoading,
      isZithas ? `zithasPaymentHistory/${obj.id}` : `paymentHistory/${obj.id}`,
      token
    )
    if (res?.success) {
      const history = res?.data?.history
      const totalAmount = res?.data?.history.reduce(
        (sum, current) => sum + Number(current.amount),
        0
      )
      const htmlContent = `
  <html>
    <body style="font-family: Calibri, sans-serif;">
      <div>
        <div class="text-end" style="text-align:right">
          <div class="mb-1" style="margin-bottom:5px;">Zithas Technologies Pvt. Ltd.</div>
          <div class="mb-1" style="margin-bottom:5px;">FF-16 Kalpvrux Complex,</div>
          <div class="mb-1" style="margin-bottom:5px;">Opp. GEB Substation, Gotri</div>
          <div class="mb-1" style="margin-bottom:5px;">Road, Vadodara Gujarat, 390021, India</div>
          <div class="mb-1" style="margin-bottom:5px;">GSTIN 24AABCZ2004K1ZL</div>
          <div class="mb-1" style="margin-bottom:5px;">www.zithas.com</div>
        </div>
        <div style="text-align:center;">
          <div class="border-bottom pb-2" style="padding-bottom:5px;border-bottom:1px solid grey;font-size:25px;font-weight:bold">INVOICE RECEIPT</div>
        </div>
        <br/>
        <div class="d-flex" style="">
          <div style="width:50%">
            <div class="mb-1" style="margin-bottom:5px;">Invoice Number: ${obj?.tax_inv_no || obj?.invoice_number
        }</div>
            <div class="mb-1" style="margin-bottom:5px;">Date of Issue: ${moment(
          obj?.created_at
        ).format("DD-MM-YYYY")}</div>
          </div>
          <br/>
          <br/>
          <div style="width:50%; text-align:right">
            <div class="mb-1" style="margin-bottom:5px;">Bill To,</div>
            <div class="mb-1" style="margin-bottom:5px;">${obj?.c_company}</div>
            <div class="mb-1" style="margin-bottom:5px;">${obj?.c_address}, ${obj?.city
        },</div>
            <div class="mb-1" style="margin-bottom:5px;">${obj?.state}, ${obj?.country
        }, ${obj?.c_zipcode}</div>
          </div>
        </div>
        <div>
          <p class="mb-2" style="font-size:20px">Invoice History</p>
          <div class="responsive-table mb-4" style="padding-bottom:20px;width:100%">
            <table class="table table-bordered mb-0 table" style="position: relative !important; border-collapse: collapse; overflow: hidden scroll !important; border: 1px solid #c6c6c6;width:100%">
              <thead>
                <tr>
                  <th class="col-md-1 text-center" style='width:8%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'><div>Id</div></th>
                  <th class="bill-col-2 text-center" style='width:20%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Received Date</th>
                  <th class="bill-col-3 text-center" style='width:15%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Payment</th>
                  <th class="bill-col-6 text-center" style='width:15%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Transaction</th>
                  <th class="text-center col-md-1" style='width:8%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>TDS</th>
                  <th class="bill-col-4 text-center" style='width:10%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Amount</th>
                </tr>
              </thead>
              <tbody>
                ${history
          ?.map(
            (obj, i) => `
                    <tr>
                      <td style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${i + 1
              }</td>
                      <td class="bill-col-2" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${moment(
                obj?.receive_date
              ).format("DD-MM-YYYY")}</td>
                      <td class="bill-col-3 text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.payment_mode
              }</td>
                      <td class="bill-col-4 text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.transaction_id || "-"
              }</td>
                      <td class="text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.tds || "-"
              }</td>
                      <td class="bill-col-4 text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.amount
              }</td>
                    </tr>
                  `
          )
          .join("")}
              </tbody>
            </table>
            <br/>
            <div style='text-align:right'><span style='font-weight:bold;'>Total :</span> ${totalAmount} </div>
          </div>
          <br/>
          <br/>
          <br/>
        </div>
        <div class="mt-3" style="margin-top:10px;">
          <div class="mb-0" style="margin-bottom:0px;">Notes : </div>
          <div>Thank you for your payment! We appreciate your promptness and look forward to continuing our business relationship.</div>
        </div>
        <br/>
        <br/>
        <div style='text-align:center'>
          <div>This receipt confirms that the above invoice has been paid in full.</div>
        </div>
      </div>
    </body>
  </html>
`

      html2pdf()
        .from(htmlContent)
        .set({
          margin: 10,
          filename: `Invoice Receipt Sheet-${obj?.tax_inv_no || obj?.invoice_number
            }.pdf`,
          html2canvas: { scale: 2 },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .save()
      if (isZithas) {
        setStatus("zithas")
      } else {
        setStatus("ztpl")
      }
      const response = await fetchData(
        toggleLoading,
        `${isZithas
          ? `changeZithasReceiptStatus/${obj?.id}`
          : `changeReceiptStatus/${obj?.id}`
        }`,
        token
      )
      if (response?.success) {
        Swal.fire({
          icon: "success",
          text: "Receipt Downloaded Successfully",
        }).then(() => {
          setData(
            isZithas
              ? response?.data?.zithas_invoice
              : response?.data?.ztpl_invoice
          )
          setAllData(response?.data)
        })
      }
    }
  }

  const onCreateCustomer = async (id, edit, obj) => {
    setLeadId(id)
    if (edit == "edit") {
      const res = await fetchNodeData(
        setLoading,
        `tempCustomer/${obj?.temp_customer}`,
        token
      )
      if (res?.success) {
        setIsEdit(true)
        setCustomerOpen(true)
        setCustomerDetails(res?.data)
      }
    } else {
      setIsEdit(false)
      setCustomerOpen(true)
    }
  }
  const changeStatusLead = async (id, status) => {
    const formEntires = {
      lead_id: id,
      status: status,
    }
    const res = await FetchNodePostData(
      setLoading,
      "leadCOPstatus",
      token,
      formEntires
    )
    return res
  }
  const onCreateInvoice = async (type, obj) => {
    Swal.fire({
      icon: "warning",
      title: "Are You Sure ?",
      text: "You Want to Create Invoice?",
      showCancelButton: true,
      confirmButtonText: "Yes, create it!",
      cancelButtonText: "No, cancel!",
    }).then(async isOkay => {
      if (isOkay?.isConfirmed) {
        const res = await changeStatusLead(obj?.id, 3)
        if (res?.data?.success) {
          if (type == "ztpl") {
            navigate(
              `${configure.appUrl}performa_invoice/ztpl#lead-${obj?.temp_customer}`
            )
          } else if (type == "zithas") {
            navigate(
              `${configure.appUrl}invoice/zithas_invoice#lead-${obj?.temp_customer}`
            )
          }
        }
      }
    })
  }

  const onInvoicePaid = obj => {
    setInvoiceOpen(true)
    setLeadId(obj?.id)
    setTempCustomerId(obj?.temp_customer)
  }

  const column1 = useMemo(() => {
    if (status == "requested") {
      return requestedInvoiceColumns(
        onCreateCustomer,
        onCreateInvoice,
        onInvoicePaid
      )
    } else if (status == "receipts") {
      return ReceiptsInvoiceColumns(
        onPaymentRecord,
        onCovertTax,
        onDownloadReceipt,
        status
      )
    }
    return pendingInvoiceColumns(
      onPaymentRecord,
      onCovertTax,
      onDownloadReceipt,
      status,
      isPrivilegedUser
    )
  }, [status, columnKey, isPrivilegedUser])

  const fetchInvoices = async (type = "ztpl") => {
    const res = await fetchData(toggleLoading, "invoiceData", token)

    if (res?.data) {
      const authId = Number(localStorage?.getItem("auth_id"))
      const filterByBA = inv =>
        isPrivilegedUser || Number(inv?.assignedBA) === authId

      const ztplInvoices = (res.data.ztpl_invoice || []).filter(filterByBA)
      const zithasInvoices = (res.data.zithas_invoice || []).filter(filterByBA)

      const filteredAllData = {
        ...res.data,
        ztpl_invoice: ztplInvoices,
        zithas_invoice: zithasInvoices,
      }

      const invoices = type == "ztpl" ? ztplInvoices : zithasInvoices

      setData(invoices.filter(inv => inv.due_flag == 0 && inv.approve == 1))
      setAllData(filteredAllData)

      const response = await fetchData(toggleLoading, "financeModes", token)
      if (response?.success) {
        setPaymentOption(
          response.data.map(obj => ({
            value: obj.id,
            label: obj.payment_mode,
          }))
        )
      }
    }
  }

  useEffect(() => {
    fetchInvoices()
  }, [])

  const onAddPayment = async e => {
    e.preventDefault()
    let exchangeRate
    if (invoiceDetail?.currency_name !== "INR") {
      setLoading(true)
      try {
        const response = await axios.get(
          `https://api.apilayer.com/fixer/${receivedDate}?symbols=INR&base=${invoiceDetail?.currency_name}`,
          {
            headers: {
              apikey: configure.exchangeKey,
            },
          }
        )
        setLoading(false)
        if (response?.data?.success) {
          exchangeRate = response.data.rates.INR
        }
      } catch (error) {
        console.warn("Primary API failed, trying fallback:", error.message)
      }
    }
    const formEntries = {
      invoice_id: invoiceDetail?.id,
      amount: amount,
      exchange_rate: invoiceDetail?.currency_name !== "INR" ? exchangeRate : 1,
      payment_mode: payment?.label,
      tds: tds || 0,
      receive_date: receivedDate,
      transaction_charge: transactionCharge || 0,
      transaction_id: transactionId,
      transaction_detail: description,
    }
    const res = await FetchPostData(
      toggleLoading,
      `${status === "zithas"
        ? "zithasInvoicePaymentRecord"
        : "invoicePaymentRecord"
      }`,
      token,
      formEntries
    )
    if (res?.data?.success) {
      Swal.fire({
        icon: "success",
        title: "Payment Record Added Successfully",
      }).then(() => {
        resetForm()
        setHistoryData(res?.data?.data.history)
        setInvoiceDetail({
          ...invoiceDetail,
          due_amount: res?.data?.data?.due_amount,
        })
      })
    }
  }

  const onEditPayment = async e => {
    e.preventDefault()
    const formEntries = {
      id: editingPaymentId,
      receive_date: receivedDate,
      payment_details: description,
      amount: amount,
      tds: tds || 0,
      transaction_charge: transactionCharge || 0,
      transaction_id: transactionId,
      payment_mode: payment?.label,
      user_id: localStorage.getItem("auth_id"),
    }

    const res = await axios.post(
      `${configure.nodeApi}/editPaymentMethod/${status === "zithas" ? "zithas" : "ztpl"
      }`,
      formEntries
    )
    if (res?.status === 200) {
      Swal.fire({
        icon: "success",
        title: "Payment Record Updated Successfully",
      }).then(async () => {
        resetForm()
        await onPaymentRecord(invoiceDetail)
        setHistoryData(res?.data?.data.history)
        // setInvoiceDetail({
        //   ...invoiceDetail,
        //   due_amount: res?.data?.data?.due_amount,
        // })
      })
    }
  }

  const getPendingCustomer = async () => {
    const res = await fetchNodeData(() => { }, "invoiceRequested", token)
    if (res?.success) {
      setPendingCustomer(res?.data)
    }
  }

  useEffect(() => {
    getPendingCustomer()
  }, [])

  const updateData = load => {
    if (load) {
      setCustomerOpen(false)
      getPendingCustomer()
      setColumnKey(prev => !prev)
    }
  }

  const onPaidInvoice = async e => {
    e.preventDefault()
    const formEntries = {
      lead_id: leadId,
      invoice_no: invoiceNo,
    }
    const res = await FetchNodePostData(
      setLoading,
      "invoicePaid",
      token,
      formEntries
    )
    if (res?.data?.success) {
      Swal?.fire({
        icon: "success",
        text: "Invoice Paid Marked Successfully",
      }).then(() => {
        if (tempCustomerId) {
          navigate(`${configure.appUrl}customer-onboarding/${tempCustomerId}`)
        }
      })
      const res = await changeStatusLead(leadId, 4)
      if (res?.data?.success) {
        getPendingCustomer()
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Invoice Not Found in Database ! Please Enter Correct Invoice No",
      })
    }
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="">
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <div className="responsive-table" key={columnKey}>
                  <TableContainer
                    columns={column1}
                    data={data}
                    allData={allData}
                    toggleLoading={toggleLoading}
                    status={status}
                    setStatus={setStatus}
                    setData={setData}
                    staticPendingCustomer={pendingCustomer}
                    totalReceipts={totalReceipts}
                    setTotalReceipts={setTotalReceipts}
                    isPrivilegedUser={isPrivilegedUser}
                    showTitle={showTitle}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal
        isOpen={paymentMode}
        size="xl"
        className="payment-records"
        centered
      >
        {isLoading && <Loader />}
        <div className="modal-header pe-4">
          <div className="d-flex gap-2 align-items-center">
            <h5 className="modal-title mt-0">Payment Record</h5>
            <span className="mb-0 px-3 py-1 bg-success rounded text-light">
              Total Amount:{" "}
              <span>{Number(invoiceDetail?.total).toFixed(2)}</span>
            </span>
            {/* <span className="mb-0 px-3 py-1 bg-danger rounded text-light">
              Due Amount:{" "}
              <span>{Number(invoiceDetail?.due_amount).toFixed(2)}</span>
            </span> */}
            <span className="mb-0 px-3 py-1 bg-danger rounded text-light">
              Due Amount:{" "}
              <span>
                {(() => {
                  const val = Number(invoiceDetail?.due_amount) || 0
                  const normalized = Math.abs(val) < 0.005 ? 0 : val
                  return normalized.toFixed(2)
                })()}
              </span>
            </span>
            {status === "ztpl" && (
              <span className="mb-0 px-3 py-1 bg-primary rounded text-light">
                GST:{" "}
                <span>
                  {(
                    Number(invoiceDetail?.igst || 0) +
                    Number(invoiceDetail?.cgst || 0) +
                    Number(invoiceDetail?.sgst || 0)
                  ).toFixed(2)}
                </span>
              </span>
            )}
          </div>
          <button
            type="button"
            onClick={() => {
              fetchInvoices(status)
              resetForm()
              setPaymentMode(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <div className="d-flex justify-content-between">
            <div className="col-md-6 ps-3 border-right">
              <h6 className="mb-4 text-dark">Payment History</h6>
              <Table
                bordered
                hover
                responsive
                size=""
                striped
                className="w-100"
              >
                <thead>
                  <tr>
                    <th className="bill-col-2">Received Date</th>
                    <th className="bill-col-3 text-center">Payment</th>
                    <th className="bill-col-4 text-center">Amount</th>
                    <th className="bill-col-6 text-center">Transaction</th>
                    <th className="text-center">TDS</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {historyData?.map((obj, i) => (
                    <tr key={i}>
                      <td className="bill-col-2">
                        {moment(obj?.receive_date).format("DD-MM-YYYY")}
                      </td>
                      <td className="bill-col-3 text-center">
                        {obj?.payment_mode}
                      </td>
                      <td className="bill-col-4 text-center">
                        {Number(obj?.amount).toFixed(2)}
                      </td>
                      <td className="bill-col-4 text-center">
                        {obj?.transaction_id}
                      </td>
                      <td className="text-center">{obj?.tds || "-"}</td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-secondary me-1"
                          onClick={() => onEdit(obj)}
                        >
                          <i
                            className={`bi ${isEditMode && editingPaymentId === obj.id
                              ? "bi-x-lg"
                              : "bi-pencil-fill"
                              }`}
                          ></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="info_box_1"></div>

            <form
              className="col-md-5 d-flex flex-column"
              onSubmit={isEditMode ? onEditPayment : onAddPayment}
            >
              <div className="col-md-12 row mb-4 justify-content-start align-items-end">
                <div className="col-4">
                  <Label htmlFor="formrow-firstname-Input">
                    Transaction ID
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Transaction ID"
                    value={transactionId}
                    onChange={e => setTransactionId(e.target.value)}
                  //disabled={isEditMode}
                  />
                </div>

                <div className="col-4">
                  <Label htmlFor="formrow-firstname-Input">
                    Payment Mode <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Payment"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={paymentOption}
                    value={payment}
                    onChange={e => setPayment(e)}
                    is //disabled={isEditMode}
                  />
                </div>
                <div className="col-4">
                  <Label htmlFor="formrow-firstname-Input">
                    Received Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    className="form-control"
                    value={receivedDate}
                    onChange={e => setReceivedDate(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-3">
                <div className="col-3">
                  <Label htmlFor="formrow-firstname-Input">
                    Amount <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Amount"
                    value={amount}
                    onChange={e => setAmount(e.target.value)}
                    onBlur={e => {
                      if (e.target.value > Number(invoiceDetail?.due_amount)) {
                        Swal.fire({
                          icon: "warning",
                          text: "Oops! You can't enter more than Due Amount",
                        })
                        setAmount("")
                      }
                    }}
                  //disabled={isEditMode}
                  />
                </div>
                <div className="col-3">
                  <Label htmlFor="formrow-firstname-Input">TDS</Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter TDS"
                    value={tds}
                    onChange={e => setTds(e.target.value)}
                    onBlur={e => {
                      if (
                        e.target.value >
                        Number(invoiceDetail?.due_amount) - Number(amount)
                      ) {
                        Swal.fire({
                          icon: "warning",
                          text: "Oops! You can't enter more than Due Amount",
                        })
                        setTds("")
                      }
                    }}
                  //disabled={isEditMode}
                  />
                </div>
                <div className="col-3">
                  <Label htmlFor="formrow-firstname-Input">
                    Transaction Charge
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Enter Charge"
                    value={transactionCharge}
                    onChange={e => setTransactionCharge(e.target.value)}
                  //disabled={isEditMode}
                  />
                </div>
              </div>
              <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                <div className="col-12 ps-2">
                  <label htmlFor="">Transaction Details</label>
                  <div>
                    <CKEditor
                      editor={ClassicEditor}
                      onReady={editor => { }}
                      data={description || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData()
                        setDescription(data)
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button className="btn btn-save btn-label" type="submit">
                  <i className="fas fa-save me-2 label-icon"></i>
                  {isEditMode ? "Update" : "Save"}
                </button>
                <a
                  onClick={() => {
                    fetchInvoices()
                    resetForm()
                    setPaymentMode(false)
                  }}
                  className="btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </a>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={customerOpen}
        size="xl"
        className="payment-records"
        centered
      >
        {isLoading && <Loader />}
        <div className="modal-header pe-4">
          <div className="d-flex gap-2 align-items-center">
            <h5 className="modal-title mt-0">Create Customer</h5>
          </div>
          <button
            type="button"
            onClick={() => {
              setCustomerOpen(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <CreateCustomer
            leadId={leadId}
            updateData={updateData}
            isEdit={isEdit}
            customerDetails={customerDetails}
          />
        </div>
      </Modal>
      <Modal isOpen={invoiceOpen} size="md" className="" centered>
        {isLoading && <Loader />}
        <div className="modal-header pe-4">
          <div className="d-flex gap-2 align-items-center">
            <h5 className="modal-title mt-0">Invoice Paid</h5>
          </div>
          <button
            type="button"
            onClick={() => {
              setInvoiceOpen(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              ×
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Row className="px-1">
            <form onSubmit={onPaidInvoice}>
              <div className="col-md-12 mb-3 ">
                <label htmlFor="">
                  Invoice Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Invoice Number"
                  className="form-control "
                  value={invoiceNo}
                  onChange={e => setInvoiceNo(e.target.value)}
                />
              </div>
              <div className="col-md-12 text-end">
                <button
                  type="submit"
                  className=" btn ms-md-2 btn-save btn-label"
                  onClick={() => setSave("0")}
                >
                  <i className="fas fa-save me-1 label-icon"></i> save
                </button>
              </div>
            </form>
          </Row>
        </div>
      </Modal>

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default PendingInvoices




































// import React, { useState, useMemo, useEffect } from "react"
// import {
//   Row,
//   Col,
//   Card,
//   Table,
//   Modal,
//   Label,
//   Form,
//   Input,
//   ModalBody,
// } from "reactstrap"
// import {
//   useTable,
//   useSortBy,
//   usePagination,
//   useGlobalFilter,
// } from "react-table"
// // assets
// import Loader from "pages/Separate/Loader"
// import NewPagination from "components/Common/Newpagination"
// import AccessDeniedPopup from "routes/AccessDeniedPopup"
// import secureLocalStorage from "react-secure-storage"
// import { customGlobalFilter } from "utils/common-helpers"
// import {
//   pendingInvoiceColumns,
//   ReceiptsInvoiceColumns,
//   requestedInvoiceColumns,
// } from "utils/columns/ElementsColumns/financeColumns"
// import { colourStyles } from "utils/common-options"
// import Select from "react-select"
// import { CKEditor } from "@ckeditor/ckeditor5-react"
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
// import {
//   fetchData,
//   fetchNodeData,
//   FetchNodePostData,
//   FetchNodePutData,
//   FetchPostData,
// } from "utils/common-fetchData"
// import Swal from "sweetalert2"
// import axios from "axios"
// import moment from "moment"
// import HTMLDocx from "html-docx-js/dist/html-docx"
// import configure from "configure"
// import CreateCustomer from "./CustomerCreate"
// import { useNavigate } from "react-router-dom"
// import html2pdf from "html2pdf.js"

// function TableContainer({
//   columns,
//   data,
//   allData,
//   status,
//   setStatus,
//   setData,
//   staticPendingCustomer,
//   totalReceipts,
//   setTotalReceipts,
// }) {
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     state,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     setPageSize,
//     pageOptions,
//     setGlobalFilter,
//     pageCount,
//     prepareRow,
//   } = useTable(
//     {
//       columns,
//       data,
//       globalFilter: customGlobalFilter,
//       autoResetPage: false,
//       initialState: {
//         sortBy: [
//           {
//             id: "id",
//             desc: true,
//           },
//         ],
//       },
//     },
//     useGlobalFilter,
//     useSortBy,
//     usePagination
//   )
//   const { pageIndex, pageSize, globalFilter } = state
//   const [ztplReceipts, setZtplReceipts] = useState([])
//   const [zithasReceipts, setZithasReceipts] = useState([])
//   const [finalReceipts, setFinalReceipts] = useState([])

//   useEffect(() => {
//     setPageSize(10)
//   }, [])
//   // Render the UI for your table
//   const [fixedHeading, setFixedHeading] = useState(false)
//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 40) {
//       setFixedHeading(true)
//     } else {
//       setFixedHeading(false)
//     }
//   })

//   // const getReceiptsList = () => {
//   //   if (!allData) return []

//   //   const ztplList = Array.isArray(allData?.ztpl_invoice)
//   //     ? allData.ztpl_invoice.filter(
//   //         inv =>
//   //           inv.due_flag == 1 &&
//   //           inv.receipt_status == 0 &&
//   //           inv.tax_inv_no !== null
//   //       )
//   //     : []

//   //   const zithasList = Array.isArray(allData?.zithas_invoice)
//   //     ? allData.zithas_invoice.filter(inv => inv.due_flag == 1)
//   //     : []

//   //   setZtplReceipts(ztplList)
//   //   setZithasReceipts(zithasList)

//   //   const merged = [...ztplList, ...zithasList]
//   //   setFinalReceipts(merged)

//   //   return merged
//   // }

//   const getReceiptsList = () => {
//     if (!allData) return []

//     const ztplList = Array.isArray(allData?.ztpl_invoice)
//       ? allData.ztpl_invoice
//         .filter(
//           inv =>
//             inv.due_flag == 1 &&
//             inv.receipt_status == 0 &&
//             inv.tax_inv_no !== null
//         )
//         .map(inv => ({
//           ...inv,
//           invoiceType: "ztpl",
//         }))
//       : []

//     const zithasList = Array.isArray(allData?.zithas_invoice)
//       ? allData.zithas_invoice
//         .filter(inv => inv.due_flag == 1)
//         .map(inv => ({
//           ...inv,
//           invoiceType: "zithas",
//         }))
//       : []

//     const merged = [...ztplList, ...zithasList]

//     setZtplReceipts(ztplList)
//     setZithasReceipts(zithasList)
//     setFinalReceipts(merged)

//     return merged
//   }

//   useEffect(() => {
//     if (allData) {
//       getReceiptsList()
//     }
//   }, [allData])

//   return (
//     <div>
//       <Row>
//         <Col xl="12">
//           <div className="card-body ">
//             <div className="d-flex justify-content-between mb-2">
//               <div className="mb-3 text-purple fs-5 fw-bold">
//                 Pending Invoices
//               </div>
//             </div>
//             <Row className="mb-2 justify-content-between">
//               <div className="mb-3 mb-md-0 d-flex justify-space-between align-items-center">
//                 <div className="d-flex gap-3 align-items-center col-md-6">
//                   <div className="">
//                     <select
//                       className="border-radius form-select"
//                       style={{ width: "100px" }}
//                       value={pageSize}
//                       onChange={e => setPageSize(e.target.value)}
//                     >
//                       {[10, 25, 50, 100].map(pageSize => (
//                         <option key={pageSize} value={pageSize}>
//                           Show {pageSize}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <a
//                     className={`d-flex gap-3 align-items-center general-box ${status === "ztpl" ? "bg-purple" : ""
//                       }`}
//                     onClick={() => {
//                       setStatus("ztpl")
//                       gotoPage(0)
//                       setData(
//                         allData?.ztpl_invoice?.filter(inv => inv?.due_flag == 0 && inv.approve == 1)
//                       )
//                     }}
//                   >
//                     <h5 className="text-purple mb-0">ZTPL : </h5>
//                     <h5 className="text-primary mb-0">
//                       {
//                         allData?.ztpl_invoice?.filter(inv => inv?.due_flag == 0 && inv.approve == 1)
//                           ?.length
//                       }
//                     </h5>
//                   </a>
//                   <a
//                     className={`d-flex gap-3 align-items-center general-box ${status === "zithas" ? "bg-purple" : ""
//                       }`}
//                     onClick={() => {
//                       setStatus("zithas")
//                       gotoPage(0)
//                       setData(
//                         allData?.zithas_invoice?.filter(
//                           inv => inv?.due_flag == 0 && inv.approve == 1
//                         )
//                       )
//                     }}
//                   >
//                     <h5 className="text-purple mb-0">Zithas : </h5>
//                     <h5 className="text-primary mb-0">
//                       {
//                         allData?.zithas_invoice?.filter(
//                           inv => inv?.due_flag == 0 && inv.approve == 1
//                         )?.length
//                       }
//                     </h5>
//                   </a>
//                   <a
//                     className={`d-flex gap-3 align-items-center general-box ${status === "receipts" ? "bg-purple" : ""
//                       }`}
//                     onClick={() => {
//                       setStatus("receipts")
//                       gotoPage(0)
//                       console.log("receipts data: ", finalReceipts)
//                       setData(finalReceipts)
//                     }}
//                   >
//                     <h5 className="text-purple mb-0">Receipts : </h5>
//                     <h5 className="text-primary mb-0">
//                       {finalReceipts?.length || 0}
//                     </h5>
//                   </a>
//                   <a
//                     className={`d-flex gap-3 align-items-center general-box ${status === "requested" ? "bg-purple" : ""
//                       }`}
//                     onClick={() => {
//                       setStatus("requested")
//                       gotoPage(0)
//                       setData(staticPendingCustomer)
//                     }}
//                   >
//                     <h5 className="text-purple mb-0">Requested Invoices : </h5>
//                     <h5 className="text-primary mb-0">
//                       {staticPendingCustomer?.length}
//                     </h5>
//                   </a>
//                 </div>

//                 <div className="col-md-6 d-flex justify-content-end align-items-center">
//                   <div className="col-11 cusrtom_search_box">
//                     <div className="search-box me-xxl-2 my-xxl-0 d-inline-block w-100">
//                       <div className="d-flex">
//                         <div className="position-relative w-100">
//                           <label
//                             htmlFor="search-bar-0"
//                             className="search-label w-100 mb-0"
//                           >
//                             <span id="search-bar-0-label" className="sr-only">
//                               Search this table
//                             </span>
//                             <input
//                               onChange={e => setGlobalFilter(e.target.value)}
//                               id="search-bar-0"
//                               type="text"
//                               className="border-radius form-control rounded h-100 w-100"
//                               placeholder={`Search...`}
//                               value={globalFilter || ""}
//                             />
//                           </label>
//                           <i className="bx bx-search-alt search-icon"></i>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </Row>
//             <div className="position-relative table-responsive">
//               <Table className="table table-bordered mt-4" {...getTableProps()}>
//                 <thead className={`fixed_view_payment_table`}>
//                   {headerGroups.map((headerGroup, i) => (
//                     <tr key={i} {...headerGroup.getHeaderGroupProps()}>
//                       {headerGroup.headers.map((column, index) => (
//                         <th
//                           key={index}
//                           className={`t-col-${index + 1} ${column.className}`}
//                           {...column.getHeaderProps(
//                             column.getSortByToggleProps()
//                           )}
//                         >
//                           <div className="d-flex align-items-center">
//                             <span className="flex-grow-1 text-center header-text">
//                               {column.render("Header")}
//                             </span>
//                             {column.isShortIcon && (
//                               <span
//                                 onClick={() =>
//                                   column.getSortByToggleProps().onClick()
//                                 }
//                                 className="d-flex align-items-center ms-2"
//                               >
//                                 <i
//                                   title="Ascending"
//                                   className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
//                                     ? "text-dark"
//                                     : ""
//                                     }`}
//                                 ></i>
//                                 <i
//                                   title="Descending"
//                                   className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
//                                     ? "text-dark"
//                                     : ""
//                                     }`}
//                                 ></i>
//                               </span>
//                             )}
//                           </div>
//                         </th>
//                       ))}
//                     </tr>
//                   ))}
//                 </thead>

//                 <tbody
//                   className="fix-introducer-header"
//                   {...getTableBodyProps()}
//                 >
//                   {page.map((row, i) => {
//                     prepareRow(row)
//                     return (
//                       <tr
//                         className={`row-hover `}
//                         {...row.getRowProps()}
//                         key={i}
//                       >
//                         {row.cells.map((cell, index) => (
//                           <td
//                             key={index}
//                             className={`t-col-${index + 1} ${cell.column.className
//                               }`}
//                             {...cell.getCellProps()}
//                           >
//                             {cell.render("Cell")}
//                           </td>
//                         ))}
//                       </tr>
//                     )
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//             <Row className="justify-content-md-end justify-content-center align-items-center">
//               <NewPagination
//                 gotoPage={gotoPage}
//                 canPreviousPage={canPreviousPage}
//                 previousPage={previousPage}
//                 canNextPage={canNextPage}
//                 pageIndex={pageIndex}
//                 pageOptions={pageOptions}
//                 pageSize={pageSize}
//                 page={page}
//                 data={data}
//                 nextPage={nextPage}
//               />
//             </Row>
//           </div>
//         </Col>
//       </Row>
//     </div>
//   )
// }

// const PendingInvoices = () => {
//   const [modal_Access, setAccessDenied] = useState(false)
//   const [isLoading, setLoading] = useState(false)
//   const [data, setData] = useState([])
//   const [allData, setAllData] = useState([])
//   const [paymentMode, setPaymentMode] = useState(false)
//   const [paymentOption, setPaymentOption] = useState([])
//   const token = secureLocalStorage.getItem("auth_token")
//   const [invoiceDetail, setInvoiceDetail] = useState({})
//   const [transactionId, setTransactionId] = useState("")
//   const [payment, setPayment] = useState([])
//   const [receivedDate, setReceivedDate] = useState("")
//   const [amount, setAmount] = useState("")
//   const [tds, setTds] = useState("")
//   const [transactionCharge, setTransactionCharge] = useState("")
//   const [description, setDescription] = useState("")
//   const [historyData, setHistoryData] = useState([])
//   const [status, setStatus] = useState("ztpl")
//   const [isEditMode, setEditMode] = useState(false)
//   const [customerOpen, setCustomerOpen] = useState(false)
//   const [editingPaymentId, setEditingPaymentId] = useState(null)
//   const [pendingCustomer, setPendingCustomer] = useState([])
//   const [leadId, setLeadId] = useState("")
//   const [tempCustomerId, setTempCustomerId] = useState("")
//   const [isEdit, setIsEdit] = useState(false)
//   const [customerDetails, setCustomerDetails] = useState({})
//   const [invoiceOpen, setInvoiceOpen] = useState(false)
//   const [invoiceNo, setInvoiceNo] = useState("")
//   const [totalReceipts, setTotalReceipts] = useState()

//   const navigate = useNavigate()
//   const [columnKey, setColumnKey] = useState(false)
//   const toggleLoading = loading => {
//     setLoading(loading)
//   }

//   const resetForm = () => {
//     setTransactionId("")
//     setPayment([])
//     setReceivedDate("")
//     setAmount("")
//     setTds("")
//     setTransactionCharge("")
//     setDescription("")
//     setEditMode(false)
//     setEditingPaymentId(null)
//   }

//   const onEdit = obj => {
//     if (isEditMode && editingPaymentId === obj.id) {
//       // Exit edit mode if clicking the same payment record
//       resetForm()
//     } else {
//       // Enter edit mode with selected payment details
//       setTransactionId(obj.transaction_id || "")
//       setPayment({ label: obj.payment_mode, value: obj.payment_mode })
//       setReceivedDate(obj.receive_date)
//       setAmount(obj.amount)
//       setTds(obj.tds || "")
//       setTransactionCharge(obj.transaction_charge || "")
//       setDescription(obj.transaction_detail || "")
//       setEditMode(true)
//       setEditingPaymentId(obj.id)
//     }
//   }

//   const onPaymentRecord = async obj => {
//     const res = await fetchData(
//       toggleLoading,
//       `${status === "zithas"
//         ? `zithasPaymentHistory/${obj?.id}`
//         : `paymentHistory/${obj?.id}`
//       }`,
//       token
//     )
//     if (res?.success) {
//       setHistoryData(res?.data?.history)
//       setPaymentMode(true)
//       setInvoiceDetail({
//         ...obj,
//         due_amount: res?.data?.due_amount,
//       })
//     }
//   }

//   const onCovertTax = id => {
//     Swal.fire({
//       icon: "warning",
//       title: "Are You Sure ?",
//       text: "You Want to Convert Tax to Invoice?",
//       showCancelButton: true,
//       confirmButtonText: "Yes, convert it!",
//       cancelButtonText: "No, cancel!",
//     }).then(async result => {
//       if (result?.isConfirmed) {
//         const res = await fetchData(
//           toggleLoading,
//           `convert_invoice/${id}`,
//           token
//         )
//         if (res.success) {
//           Swal.fire({
//             icon: "success",
//             title: "Invoice Converted Successfully",
//           }).then(() => {
//             setData(res.data.ztpl_invoice.filter(inv => inv.due_flag == 0 && inv.approve == 1))
//             setAllData(res.data)
//           })
//         }
//       }
//     })
//   }

//   const onDownloadReceipt = async obj => {
//     const isZithas = obj.invoiceType === "zithas" || status === "zithas"

//     const res = await fetchData(
//       toggleLoading,
//       isZithas ? `zithasPaymentHistory/${obj.id}` : `paymentHistory/${obj.id}`,
//       token
//     )
//     if (res?.success) {
//       const history = res?.data?.history
//       const totalAmount = res?.data?.history.reduce(
//         (sum, current) => sum + Number(current.amount),
//         0
//       )
//       const htmlContent = `
//   <html>
//     <body style="font-family: Calibri, sans-serif;">
//       <div>
//         <div class="text-end" style="text-align:right">
//           <div class="mb-1" style="margin-bottom:5px;">Zithas Technologies Pvt. Ltd.</div>
//           <div class="mb-1" style="margin-bottom:5px;">FF-16 Kalpvrux Complex,</div>
//           <div class="mb-1" style="margin-bottom:5px;">Opp. GEB Substation, Gotri</div>
//           <div class="mb-1" style="margin-bottom:5px;">Road, Vadodara Gujarat, 390021, India</div>
//           <div class="mb-1" style="margin-bottom:5px;">GSTIN 24AABCZ2004K1ZL</div>
//           <div class="mb-1" style="margin-bottom:5px;">www.zithas.com</div>
//         </div>
//         <div style="text-align:center;">
//           <div class="border-bottom pb-2" style="padding-bottom:5px;border-bottom:1px solid grey;font-size:25px;font-weight:bold">INVOICE RECEIPT</div>
//         </div>
//         <br/>
//         <div class="d-flex" style="">
//           <div style="width:50%">
//             <div class="mb-1" style="margin-bottom:5px;">Invoice Number: ${obj?.tax_inv_no || obj?.invoice_number
//         }</div>
//             <div class="mb-1" style="margin-bottom:5px;">Date of Issue: ${moment(
//           obj?.created_at
//         ).format("DD-MM-YYYY")}</div>
//           </div>
//           <br/>
//           <br/>
//           <div style="width:50%; text-align:right">
//             <div class="mb-1" style="margin-bottom:5px;">Bill To,</div>
//             <div class="mb-1" style="margin-bottom:5px;">${obj?.c_company}</div>
//             <div class="mb-1" style="margin-bottom:5px;">${obj?.c_address}, ${obj?.city
//         },</div>
//             <div class="mb-1" style="margin-bottom:5px;">${obj?.state}, ${obj?.country
//         }, ${obj?.c_zipcode}</div>
//           </div>
//         </div>
//         <div>
//           <p class="mb-2" style="font-size:20px">Invoice History</p>
//           <div class="responsive-table mb-4" style="padding-bottom:20px;width:100%">
//             <table class="table table-bordered mb-0 table" style="position: relative !important; border-collapse: collapse; overflow: hidden scroll !important; border: 1px solid #c6c6c6;width:100%">
//               <thead>
//                 <tr>
//                   <th class="col-md-1 text-center" style='width:8%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'><div>Id</div></th>
//                   <th class="bill-col-2 text-center" style='width:20%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Received Date</th>
//                   <th class="bill-col-3 text-center" style='width:15%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Payment</th>
//                   <th class="bill-col-6 text-center" style='width:15%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Transaction</th>
//                   <th class="text-center col-md-1" style='width:8%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>TDS</th>
//                   <th class="bill-col-4 text-center" style='width:10%;font-family: Calibri, sans-serif;border: 1px solid #c6c6c6'>Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${history
//           ?.map(
//             (obj, i) => `
//                     <tr>
//                       <td style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${i + 1
//               }</td>
//                       <td class="bill-col-2" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${moment(
//                 obj?.receive_date
//               ).format("DD-MM-YYYY")}</td>
//                       <td class="bill-col-3 text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.payment_mode
//               }</td>
//                       <td class="bill-col-4 text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.transaction_id || "-"
//               }</td>
//                       <td class="text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.tds || "-"
//               }</td>
//                       <td class="bill-col-4 text-center" style='font-family: Calibri, sans-serif;border: 1px solid #c6c6c6;text-align:center'>${obj?.amount
//               }</td>
//                     </tr>
//                   `
//           )
//           .join("")}
//               </tbody>
//             </table>
//             <br/>
//             <div style='text-align:right'><span style='font-weight:bold;'>Total :</span> ${totalAmount} </div>
//           </div>
//           <br/>
//           <br/>
//           <br/>
//         </div>
//         <div class="mt-3" style="margin-top:10px;">
//           <div class="mb-0" style="margin-bottom:0px;">Notes : </div>
//           <div>Thank you for your payment! We appreciate your promptness and look forward to continuing our business relationship.</div>
//         </div>
//         <br/>
//         <br/>
//         <div style='text-align:center'>
//           <div>This receipt confirms that the above invoice has been paid in full.</div>
//         </div>
//       </div>
//     </body>
//   </html>
// `
//       // const converted = HTMLDocx.asBlob(htmlContent)
//       // const date = new Date()
//       // const link = document.createElement("a")
//       // link.href = URL.createObjectURL(converted)
//       // link.download = `Invoice Receipt Sheet-${obj?.invoice_number}.pdf`
//       // link.click()
//       html2pdf()
//         .from(htmlContent)
//         .set({
//           margin: 10,
//           filename: `Invoice Receipt Sheet-${obj?.tax_inv_no || obj?.invoice_number}.pdf`,
//           html2canvas: { scale: 2 },
//           jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
//         })
//         .save()
//       if (isZithas) {
//         setStatus("zithas")
//       } else {
//         setStatus("ztpl")
//       }
//       const response = await fetchData(
//         toggleLoading,
//         `${isZithas
//           ? `changeZithasReceiptStatus/${obj?.id}`
//           : `changeReceiptStatus/${obj?.id}`
//         }`,
//         token
//       )
//       if (response?.success) {
//         Swal.fire({
//           icon: "success",
//           text: "Receipt Downloaded Successfully",
//         }).then(() => {
//           setData(
//             isZithas
//               ? response?.data?.zithas_invoice
//               : response?.data?.ztpl_invoice
//           )
//           setAllData(response?.data)
//         })
//       }
//     }
//   }
//   const onCreateCustomer = async (id, edit, obj) => {
//     setLeadId(id)
//     if (edit == "edit") {
//       const res = await fetchNodeData(
//         setLoading,
//         `tempCustomer/${obj?.temp_customer}`,
//         token
//       )
//       if (res?.success) {
//         setIsEdit(true)
//         setCustomerOpen(true)
//         setCustomerDetails(res?.data)
//       }
//     } else {
//       setIsEdit(false)
//       setCustomerOpen(true)
//     }
//   }
//   const changeStatusLead = async (id, status) => {
//     const formEntires = {
//       lead_id: id,
//       status: status,
//     }
//     const res = await FetchNodePostData(
//       setLoading,
//       "leadCOPstatus",
//       token,
//       formEntires
//     )
//     return res
//   }
//   const onCreateInvoice = async (type, obj) => {
//     Swal.fire({
//       icon: "warning",
//       title: "Are You Sure ?",
//       text: "You Want to Create Invoice?",
//       showCancelButton: true,
//       confirmButtonText: "Yes, create it!",
//       cancelButtonText: "No, cancel!",
//     }).then(async isOkay => {
//       if (isOkay?.isConfirmed) {
//         const res = await changeStatusLead(obj?.id, 3)
//         if (res?.data?.success) {
//           if (type == "ztpl") {
//             navigate(
//               `${configure.appUrl}performa_invoice/ztpl#lead-${obj?.temp_customer}`
//             )
//           } else if (type == "zithas") {
//             navigate(
//               `${configure.appUrl}invoice/zithas_invoice#lead-${obj?.temp_customer}`
//             )
//           }
//         }
//       }
//     })
//   }

//   const onInvoicePaid = obj => {
//     setInvoiceOpen(true)
//     setLeadId(obj?.id)
//     setTempCustomerId(obj?.temp_customer)
//   }

//   const column1 = useMemo(() => {
//     if (status == "requested") {
//       return requestedInvoiceColumns(
//         onCreateCustomer,
//         onCreateInvoice,
//         onInvoicePaid
//       )
//     } else if (status == "receipts") {
//       return ReceiptsInvoiceColumns(
//         onPaymentRecord,
//         onCovertTax,
//         onDownloadReceipt,
//         status
//       )
//     }
//     return pendingInvoiceColumns(
//       onPaymentRecord,
//       onCovertTax,
//       onDownloadReceipt,
//       status
//     )
//   }, [status, columnKey])

//   // const fetchInvoices = async () => {
//   //   const res = await fetchData(toggleLoading, "invoiceData", token)
//   //   if (res?.data) {
//   //     setData(res.data.ztpl_invoice.filter(inv => inv.due_flag == 0))
//   //     setAllData(res.data)
//   //     console.log("res.data : ", res.data)
//   //     const response = await fetchData(toggleLoading, "financeModes", token)
//   //     if (response?.success) {
//   //       setPaymentOption(
//   //         response?.data?.map(obj => ({
//   //           value: obj?.id,
//   //           label: obj?.payment_mode,
//   //         }))
//   //       )
//   //     }
//   //   }
//   // }

//   const fetchInvoices = async (type = "ztpl") => {
//     const res = await fetchData(toggleLoading, "invoiceData", token)

//     if (res?.data) {
//       // 🔹 choose invoice type
//       const invoices =
//         type == "ztpl"
//           ? res.data.ztpl_invoice // ZTPL
//           : res.data.zithas_invoice // ZITHAS

//       // 🔹 apply due_flag filter
//       setData(invoices.filter(inv => inv.due_flag == 0 && inv.approve == 1))
//       setAllData(res.data)

//       console.log("res.data : ", res.data)

//       const response = await fetchData(toggleLoading, "financeModes", token)
//       if (response?.success) {
//         setPaymentOption(
//           response.data.map(obj => ({
//             value: obj.id,
//             label: obj.payment_mode,
//           }))
//         )
//       }
//     }
//   }

//   useEffect(() => {
//     fetchInvoices()
//   }, [])

//   const onAddPayment = async e => {
//     e.preventDefault()
//     let exchangeRate
//     if (invoiceDetail?.currency_name !== "INR") {
//       setLoading(true)
//       try {
//         const response = await axios.get(
//           `https://api.apilayer.com/fixer/${receivedDate}?symbols=INR&base=${invoiceDetail?.currency_name}`,
//           {
//             headers: {
//               apikey: configure.exchangeKey,
//             },
//           }
//         )
//         setLoading(false)
//         if (response?.data?.success) {
//           exchangeRate = response.data.rates.INR
//         }
//       } catch (error) {
//         console.warn("Primary API failed, trying fallback:", error.message)
//       }
//     }
//     const formEntries = {
//       invoice_id: invoiceDetail?.id,
//       amount: amount,
//       exchange_rate: invoiceDetail?.currency_name !== "INR" ? exchangeRate : 1,
//       payment_mode: payment?.label,
//       tds: tds || 0,
//       receive_date: receivedDate,
//       transaction_charge: transactionCharge || 0,
//       transaction_id: transactionId,
//       transaction_detail: description,
//     }
//     const res = await FetchPostData(
//       toggleLoading,
//       `${status === "zithas"
//         ? "zithasInvoicePaymentRecord"
//         : "invoicePaymentRecord"
//       }`,
//       token,
//       formEntries
//     )
//     if (res?.data?.success) {
//       Swal.fire({
//         icon: "success",
//         title: "Payment Record Added Successfully",
//       }).then(() => {
//         resetForm()
//         setHistoryData(res?.data?.data.history)
//         setInvoiceDetail({
//           ...invoiceDetail,
//           due_amount: res?.data?.data?.due_amount,
//         })
//       })
//     }
//   }

//   const onEditPayment = async e => {
//     e.preventDefault()
//     const formEntries = {
//       id: editingPaymentId,
//       receive_date: receivedDate,
//       payment_details: description,
//       amount: amount,
//       tds: tds || 0,
//       transaction_charge: transactionCharge || 0,
//       transaction_id: transactionId,
//       payment_mode: payment?.label,
//       user_id: localStorage.getItem("auth_id"),
//     }

//     const res = await axios.post(
//       `${configure.nodeApi}/editPaymentMethod/${status === "zithas" ? "zithas" : "ztpl"
//       }`,
//       formEntries
//     )
//     if (res?.status === 200) {
//       Swal.fire({
//         icon: "success",
//         title: "Payment Record Updated Successfully",
//       }).then(async () => {
//         resetForm()
//         await onPaymentRecord(invoiceDetail)
//         setHistoryData(res?.data?.data.history)
//         // setInvoiceDetail({
//         //   ...invoiceDetail,
//         //   due_amount: res?.data?.data?.due_amount,
//         // })
//       })
//     }
//   }

//   const getPendingCustomer = async () => {
//     const res = await fetchNodeData(() => { }, "invoiceRequested", token)
//     if (res?.success) {
//       setPendingCustomer(res?.data)
//     }
//   }

//   useEffect(() => {
//     getPendingCustomer()
//   }, [])

//   const updateData = load => {
//     if (load) {
//       setCustomerOpen(false)
//       getPendingCustomer()
//       setColumnKey(prev => !prev)
//     }
//   }

//   const onPaidInvoice = async e => {
//     e.preventDefault()
//     const formEntries = {
//       lead_id: leadId,
//       invoice_no: invoiceNo,
//     }
//     const res = await FetchNodePostData(
//       setLoading,
//       "invoicePaid",
//       token,
//       formEntries
//     )
//     if (res?.data?.success) {
//       Swal?.fire({
//         icon: "success",
//         text: "Invoice Paid Marked Successfully",
//       }).then(() => {
//         if (tempCustomerId) {
//           navigate(`${configure.appUrl}customer-onboarding/${tempCustomerId}`)
//         }
//       })
//       const res = await changeStatusLead(leadId, 4)
//       if (res?.data?.success) {
//         getPendingCustomer()
//       }
//     } else {
//       Swal.fire({
//         icon: "warning",
//         text: "Invoice Not Found in Database ! Please Enter Correct Invoice No",
//       })
//     }
//   }

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="">
//         <div>
//           <Row>
//             <Col lg="12">
//               <Card>
//                 <div className="responsive-table" key={columnKey}>
//                   <TableContainer
//                     columns={column1}
//                     data={data}
//                     allData={allData}
//                     toggleLoading={toggleLoading}
//                     status={status}
//                     setStatus={setStatus}
//                     setData={setData}
//                     staticPendingCustomer={pendingCustomer}
//                     totalReceipts={totalReceipts}
//                     setTotalReceipts={setTotalReceipts}
//                   />
//                 </div>
//               </Card>
//             </Col>
//           </Row>
//         </div>
//       </div>

//       <Modal
//         isOpen={paymentMode}
//         size="xl"
//         className="payment-records"
//         centered
//       >
//         {isLoading && <Loader />}
//         <div className="modal-header pe-4">
//           <div className="d-flex gap-2 align-items-center">
//             <h5 className="modal-title mt-0">Payment Record</h5>
//             <span className="mb-0 px-3 py-1 bg-success rounded text-light">
//               Total Amount:{" "}
//               <span>{Number(invoiceDetail?.total).toFixed(2)}</span>
//             </span>
//             <span className="mb-0 px-3 py-1 bg-danger rounded text-light">
//               Due Amount:{" "}
//               <span>{Number(invoiceDetail?.due_amount).toFixed(2)}</span>
//             </span>
//             {status === "ztpl" && (
//               <span className="mb-0 px-3 py-1 bg-primary rounded text-light">
//                 GST:{" "}
//                 <span>
//                   {(
//                     Number(invoiceDetail?.igst || 0) +
//                     Number(invoiceDetail?.cgst || 0) +
//                     Number(invoiceDetail?.sgst || 0)
//                   ).toFixed(2)}
//                 </span>
//               </span>
//             )}
//           </div>
//           <button
//             type="button"
//             onClick={() => {
//               fetchInvoices(status)
//               resetForm()
//               setPaymentMode(false)
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <div className="d-flex justify-content-between">
//             <div className="col-md-6 ps-3 border-right">
//               <h6 className="mb-4 text-dark">Payment History</h6>
//               <Table
//                 bordered
//                 hover
//                 responsive
//                 size=""
//                 striped
//                 className="w-100"
//               >
//                 <thead>
//                   <tr>
//                     <th className="bill-col-2">Received Date</th>
//                     <th className="bill-col-3 text-center">Payment</th>
//                     <th className="bill-col-4 text-center">Amount</th>
//                     <th className="bill-col-6 text-center">Transaction</th>
//                     <th className="text-center">TDS</th>
//                     <th className="text-center">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {historyData?.map((obj, i) => (
//                     <tr key={i}>
//                       <td className="bill-col-2">
//                         {moment(obj?.receive_date).format("DD-MM-YYYY")}
//                       </td>
//                       <td className="bill-col-3 text-center">
//                         {obj?.payment_mode}
//                       </td>
//                       <td className="bill-col-4 text-center">
//                         {Number(obj?.amount).toFixed(2)}
//                       </td>
//                       <td className="bill-col-4 text-center">
//                         {obj?.transaction_id}
//                       </td>
//                       <td className="text-center">{obj?.tds || "-"}</td>
//                       <td className="text-center">
//                         <button
//                           className="btn btn-sm btn-outline-secondary me-1"
//                           onClick={() => onEdit(obj)}
//                         >
//                           <i
//                             className={`bi ${isEditMode && editingPaymentId === obj.id
//                               ? "bi-x-lg"
//                               : "bi-pencil-fill"
//                               }`}
//                           ></i>
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//             <div className="info_box_1"></div>

//             <form
//               className="col-md-5 d-flex flex-column"
//               onSubmit={isEditMode ? onEditPayment : onAddPayment}
//             >
//               <div className="col-md-12 row mb-4 justify-content-start align-items-end">
//                 <div className="col-4">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Transaction ID
//                   </Label>
//                   <Input
//                     type="text"
//                     className="form-control"
//                     placeholder="Transaction ID"
//                     value={transactionId}
//                     onChange={e => setTransactionId(e.target.value)}
//                   //disabled={isEditMode}
//                   />
//                 </div>

//                 <div className="col-4">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Payment Mode <span className="text-danger">*</span>
//                   </Label>
//                   <Select
//                     placeholder="Payment"
//                     className="basic-multi-select"
//                     classNamePrefix="select"
//                     styles={colourStyles}
//                     options={paymentOption}
//                     value={payment}
//                     onChange={e => setPayment(e)}
//                     is //disabled={isEditMode}
//                   />
//                 </div>
//                 <div className="col-4">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Received Date <span className="text-danger">*</span>
//                   </Label>
//                   <Input
//                     type="date"
//                     className="form-control"
//                     value={receivedDate}
//                     onChange={e => setReceivedDate(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end gap-3">
//                 <div className="col-3">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Amount <span className="text-danger">*</span>
//                   </Label>
//                   <Input
//                     type="text"
//                     className="form-control"
//                     placeholder="Enter Amount"
//                     value={amount}
//                     onChange={e => setAmount(e.target.value)}
//                     onBlur={e => {
//                       if (e.target.value > Number(invoiceDetail?.due_amount)) {
//                         Swal.fire({
//                           icon: "warning",
//                           text: "Oops! You can't enter more than Due Amount",
//                         })
//                         setAmount("")
//                       }
//                     }}
//                   //disabled={isEditMode}
//                   />
//                 </div>
//                 <div className="col-3">
//                   <Label htmlFor="formrow-firstname-Input">TDS</Label>
//                   <Input
//                     type="text"
//                     className="form-control"
//                     placeholder="Enter TDS"
//                     value={tds}
//                     onChange={e => setTds(e.target.value)}
//                   //disabled={isEditMode}
//                   />
//                 </div>
//                 <div className="col-3">
//                   <Label htmlFor="formrow-firstname-Input">
//                     Transaction Charge
//                   </Label>
//                   <Input
//                     type="text"
//                     className="form-control"
//                     placeholder="Enter Charge"
//                     value={transactionCharge}
//                     onChange={e => setTransactionCharge(e.target.value)}
//                   //disabled={isEditMode}
//                   />
//                 </div>
//               </div>
//               <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
//                 <div className="col-12 ps-2">
//                   <label htmlFor="">Transaction Details</label>
//                   <div>
//                     <CKEditor
//                       editor={ClassicEditor}
//                       onReady={editor => { }}
//                       data={description || ""}
//                       onChange={(event, editor) => {
//                         const data = editor.getData()
//                         setDescription(data)
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="text-right">
//                 <button className="btn btn-save btn-label" type="submit">
//                   <i className="fas fa-save me-2 label-icon"></i>
//                   {isEditMode ? "Update" : "Save"}
//                 </button>
//                 <a
//                   onClick={() => {
//                     fetchInvoices()
//                     resetForm()
//                     setPaymentMode(false)
//                   }}
//                   className="btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </a>
//               </div>
//             </form>
//           </div>
//         </div>
//       </Modal>
//       <Modal
//         isOpen={customerOpen}
//         size="xl"
//         className="payment-records"
//         centered
//       >
//         {isLoading && <Loader />}
//         <div className="modal-header pe-4">
//           <div className="d-flex gap-2 align-items-center">
//             <h5 className="modal-title mt-0">Create Customer</h5>
//           </div>
//           <button
//             type="button"
//             onClick={() => {
//               setCustomerOpen(false)
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <CreateCustomer
//             leadId={leadId}
//             updateData={updateData}
//             isEdit={isEdit}
//             customerDetails={customerDetails}
//           />
//         </div>
//       </Modal>
//       <Modal isOpen={invoiceOpen} size="md" className="" centered>
//         {isLoading && <Loader />}
//         <div className="modal-header pe-4">
//           <div className="d-flex gap-2 align-items-center">
//             <h5 className="modal-title mt-0">Invoice Paid</h5>
//           </div>
//           <button
//             type="button"
//             onClick={() => {
//               setInvoiceOpen(false)
//             }}
//             className="btn-modal-close"
//           >
//             <span aria-hidden="true" className="btn-modal-span">
//               ×
//             </span>
//           </button>
//         </div>

//         <div className="modal-body pe-4">
//           <Row className="px-1">
//             <form onSubmit={onPaidInvoice}>
//               <div className="col-md-12 mb-3 ">
//                 <label htmlFor="">
//                   Invoice Number <span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   placeholder="Enter Invoice Number"
//                   className="form-control "
//                   value={invoiceNo}
//                   onChange={e => setInvoiceNo(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-12 text-end">
//                 <button
//                   type="submit"
//                   className=" btn ms-md-2 btn-save btn-label"
//                   onClick={() => setSave("0")}
//                 >
//                   <i className="fas fa-save me-1 label-icon"></i> save
//                 </button>
//               </div>
//             </form>
//           </Row>
//         </div>
//       </Modal>

//       <AccessDeniedPopup
//         modal_Access={modal_Access}
//         setAccessDenied={setAccessDenied}
//       />
//     </React.Fragment>
//   )
// }

// export default PendingInvoices
